<template>
  <div
    v-for="(item, index) in marketSelectList"
    @click="handleMarketItemChecked(item, index)"
    :key="item.id"
    class="market-list-item one-px"
  >
    <span :class="`${toggleCheckedClass(item)}`"></span>
    <MarketCard :type="type" :item="item" :firstSelectItem="firstSelectItem" />
  </div>
</template>

<script setup lang="tsx">
  import { toRefs } from 'vue';
  import MarketCard from './index.vue';

  type TProps = {
    // 营销业务类型
    type: string;
    // 一级导航选中项
    firstSelectItem: any;
    // 已选择数量
    selectedMarketItems: any[];
    // 营销选择列表
    marketSelectList: any[];
    // 可编辑选择数量
    enabledSelectedMarketList: any[];
    // 最大选择数量
    maxSeclectCount: number;
    // 处理选中逻辑
    handleMarketItemChecked: (item: any, index: number) => void;
  };
  const props = defineProps<TProps>();
  const { marketSelectList } = toRefs(props);
  const { handleMarketItemChecked } = props;

  const toggleCheckedClass = (item: any) => {
    if (props.selectedMarketItems?.findIndex((i) => i.id === item.id) > -1) {
      if (props.selectedMarketItems?.findIndex((i) => i.disabled && i.id === item.id) > -1) {
        return 'cz-iconfont czicon-test15-copy market-item-radio checked checkdisabled';
      }
      return 'cz-iconfont czicon-test15-copy market-item-radio checked';
    } else {
      if (props.enabledSelectedMarketList?.length >= props.maxSeclectCount) {
        return 'market-item-radio disabled';
      }
      return 'cz-iconfont czcircle market-item-radio';
    }
  };
</script>

<style lang="less">
  // 滚动列表容器
  .market-list-scroll-box {
    .market-list-item {
      display: flex;
      // align-items: baseline;
      align-items: flex-start;
      width: 100%;
      line-height: normal;
      padding: 0.3rem 0;
      // 禁止1px下边线引起的滚动
      overflow: hidden;

      &.one-px::after {
        width: calc(100% + 0.6rem);
      }

      // 单选按钮
      .market-item-radio {
        position: relative;
        top: 0.03rem;
        margin-right: 12px;
        font-size: 0.36rem;
        color: #9aa9c3;
        &.disabled {
          display: block;
          width: 18px;
          height: 18px;
          background-color: #e7e6e6;
          border-radius: 10px;
          font-size: 0;
          border: 1px solid #ccc;
          box-sizing: border-box;
        }
        &.checked {
          color: #3078db;
        }
        &.checked.checkdisabled {
          color: #ccc;
        }
      }
    }
  }
</style>
